module.exports = __webpack_public_path__ + "img/redux.3e3672b7.svg";